import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

const SearchItem = styled('li')(({ theme }) => ({
  display: 'flex',
  gap: '2px',
  alignItems: 'center!important',
  minHeight: '62px !important',
  padding: '8px 16px',

  '&.MuiAutocomplete-option[aria-selected="true"]': {
    backgroundColor: `${theme.palette.background.grey.light}`
  },

  '&.Mui-focusVisible': {
    backgroundColor: `${theme.palette.background.grey.main} !important`
  },

  '&.Mui-focused': {
    backgroundColor: `${theme.palette.background.cyan.light} !important`,
    '& p[aria-label="naics6"] span': {
      color: `${theme.palette.text.primary} !important`
    },
    '& p[aria-label="naics2"] span': {
      color: `${theme.palette.text.tertiary} !important`
    }
  },

  // pressing mouse down on item
  '&:active': {
    backgroundColor: `${theme.palette.background.cyan.light} !important`
  }
}));

export const isOptionEqualToValue = (option, valueOption) => option.label === valueOption.label;

export const renderOption = (props, option, { inputValue }) => {
  const { key, ...restProps } = props;
  const matches = match(option.label, inputValue, {
    insideWords: true,
    findAllOccurrences: true
  });
  const partsNaicsTitle = parse(option.label, matches);

  return (
    <SearchItem
      key={key}
      {...restProps}
    >
      <Text
        aria-label="naics"
        component="p"
      >
        {partsNaicsTitle.map((part, index) => (
          <Text
            color="primary"
            component="span"
            // eslint-disable-next-line react/no-array-index-key
            key={`${part.text}-${index}`}
            size="md"
            weight={part.highlight ? 'medium' : 'regular'}
          >
            {part.text}
          </Text>
        ))}
      </Text>
    </SearchItem>
  );
};
